import { render, staticRenderFns } from "./MarketDetails.vue?vue&type=template&id=7c36953f&scoped=true"
import script from "./MarketDetails.vue?vue&type=script&lang=js"
export * from "./MarketDetails.vue?vue&type=script&lang=js"
import style0 from "./MarketDetails.vue?vue&type=style&index=0&id=7c36953f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36953f",
  null
  
)

export default component.exports